import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  myCards: [],
  receivedCards: [],
  cardDetail: {}
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
